"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityInterestDtoFormVersionEnum = void 0;
exports.instanceOfFacilityInterestDto = instanceOfFacilityInterestDto;
exports.FacilityInterestDtoFromJSON = FacilityInterestDtoFromJSON;
exports.FacilityInterestDtoFromJSONTyped = FacilityInterestDtoFromJSONTyped;
exports.FacilityInterestDtoToJSON = FacilityInterestDtoToJSON;
exports.FacilityInterestDtoToJSONTyped = FacilityInterestDtoToJSONTyped;
const InterestWorkType_1 = require("./InterestWorkType");
const TravelWillingness_1 = require("./TravelWillingness");
const ContactPreference_1 = require("./ContactPreference");
const InterestShiftLength_1 = require("./InterestShiftLength");
const InterestAvailability_1 = require("./InterestAvailability");
const InterestShiftType_1 = require("./InterestShiftType");
const WorkTypePreference_1 = require("./WorkTypePreference");
/**
 * @export
 */
exports.FacilityInterestDtoFormVersionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
};
/**
 * Check if a given object implements the FacilityInterestDto interface.
 */
function instanceOfFacilityInterestDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('formVersion' in value) || value['formVersion'] === undefined)
        return false;
    if (!('workTypePreference' in value) || value['workTypePreference'] === undefined)
        return false;
    if (!('willingToTravel' in value) || value['willingToTravel'] === undefined)
        return false;
    if (!('specialtyCodes' in value) || value['specialtyCodes'] === undefined)
        return false;
    if (!('workTypes' in value) || value['workTypes'] === undefined)
        return false;
    if (!('workTypeOther' in value) || value['workTypeOther'] === undefined)
        return false;
    if (!('shiftTypes' in value) || value['shiftTypes'] === undefined)
        return false;
    if (!('shiftTypeOther' in value) || value['shiftTypeOther'] === undefined)
        return false;
    if (!('shiftLengths' in value) || value['shiftLengths'] === undefined)
        return false;
    if (!('availability' in value) || value['availability'] === undefined)
        return false;
    if (!('availabilityOther' in value) || value['availabilityOther'] === undefined)
        return false;
    if (!('minimumRate' in value) || value['minimumRate'] === undefined)
        return false;
    if (!('contactPreference' in value) || value['contactPreference'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
function FacilityInterestDtoFromJSON(json) {
    return FacilityInterestDtoFromJSONTyped(json, false);
}
function FacilityInterestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'facilityId': json['facilityId'],
        'nurseProfileId': json['nurseProfileId'],
        'formVersion': json['formVersion'],
        'workTypePreference': (0, WorkTypePreference_1.WorkTypePreferenceFromJSON)(json['workTypePreference']),
        'willingToTravel': (0, TravelWillingness_1.TravelWillingnessFromJSON)(json['willingToTravel']),
        'specialtyCodes': json['specialtyCodes'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'startDateComment': json['startDateComment'] == null ? undefined : json['startDateComment'],
        'workTypes': (json['workTypes'].map(InterestWorkType_1.InterestWorkTypeFromJSON)),
        'workTypeOther': json['workTypeOther'],
        'shiftTypes': (json['shiftTypes'].map(InterestShiftType_1.InterestShiftTypeFromJSON)),
        'shiftTypeOther': json['shiftTypeOther'],
        'shiftLengths': (json['shiftLengths'].map(InterestShiftLength_1.InterestShiftLengthFromJSON)),
        'availability': (0, InterestAvailability_1.InterestAvailabilityFromJSON)(json['availability']),
        'availabilityOther': json['availabilityOther'],
        'minimumRate': json['minimumRate'],
        'contactPreference': (0, ContactPreference_1.ContactPreferenceFromJSON)(json['contactPreference']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function FacilityInterestDtoToJSON(json) {
    return FacilityInterestDtoToJSONTyped(json, false);
}
function FacilityInterestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'facilityId': value['facilityId'],
        'nurseProfileId': value['nurseProfileId'],
        'formVersion': value['formVersion'],
        'workTypePreference': (0, WorkTypePreference_1.WorkTypePreferenceToJSON)(value['workTypePreference']),
        'willingToTravel': (0, TravelWillingness_1.TravelWillingnessToJSON)(value['willingToTravel']),
        'specialtyCodes': value['specialtyCodes'],
        'comment': value['comment'],
        'startDateComment': value['startDateComment'],
        'workTypes': (value['workTypes'].map(InterestWorkType_1.InterestWorkTypeToJSON)),
        'workTypeOther': value['workTypeOther'],
        'shiftTypes': (value['shiftTypes'].map(InterestShiftType_1.InterestShiftTypeToJSON)),
        'shiftTypeOther': value['shiftTypeOther'],
        'shiftLengths': (value['shiftLengths'].map(InterestShiftLength_1.InterestShiftLengthToJSON)),
        'availability': (0, InterestAvailability_1.InterestAvailabilityToJSON)(value['availability']),
        'availabilityOther': value['availabilityOther'],
        'minimumRate': value['minimumRate'],
        'contactPreference': (0, ContactPreference_1.ContactPreferenceToJSON)(value['contactPreference']),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}
//# sourceMappingURL=FacilityInterestDto.js.map